import { render, staticRenderFns } from "./Microphone.vue?vue&type=template&id=382bd021&scoped=true&lang=pug"
import script from "./Microphone.vue?vue&type=script&lang=ts"
export * from "./Microphone.vue?vue&type=script&lang=ts"
import style0 from "./Microphone.vue?vue&type=style&index=0&id=382bd021&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382bd021",
  null
  
)

export default component.exports